import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';

export default function Footer() {
  return (
        <footer className="py-8 px-6 bg-indigo-900/10 dark:bg-gray-900/80 backdrop-blur-md">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="mb-4 md:mb-0">
                <h2 className="text-xl font-bold text-indigo-700 dark:text-indigo-300">Shambhavi Singh</h2>
                <p className="text-sm text-gray-600 dark:text-gray-400"></p>
              </div>

              <div className="flex space-x-6">
                <motion.a
                  href="https://github.com/ShambhaviSingh16"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -3 }}
                  className="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400"
                >
                  <FiGithub size={20} />
                </motion.a>
                <motion.a
                  href="https://www.linkedin.com/in/shambhavi-singh2023"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -3 }}
                  className="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400"
                >
                  <FiLinkedin size={20} />
                </motion.a>
                <motion.a
                  href="mailto:sshambhavi89@gmail.com"
                  whileHover={{ y: -3 }}
                  className="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400"
                >
                  <FiMail size={20} />
                </motion.a>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-800 text-center text-sm text-gray-600 dark:text-gray-400">
              <p>© {new Date().getFullYear()} Shambhavi Singh. All rights reserved.</p>
            </div>
          </div>
        </footer>
  );
}
